<template>
  <Layout :removePadding="true">
    <v-progress-circular
      v-if="!userData"
      indeterminate
      color="primary"
      class="absolute-center"
    ></v-progress-circular>
    <div v-else>
      <BalanceData
        :balance="userData.balance"
        :tokens="userData.tokens"
        :routeNames="routeNames"
      ></BalanceData>
      <v-main>
        <div fluid class="d-flex align-center px-8 pt-2 mt-2">
          <div
            v-if="availablePayment"
            style="background: #000230; cursor: pointer; border-radius: 1rem; height: 5.9rem; color: #fff;"
            class="mr-1 w-100 pa-5 d-flex flex-column flex-sm-row align-center justify-center text-center"
            @click="$router.push({ name: routeNames.RECHARGE })"
          >
            <div class="d-flex align-center justify-center" :class="allowRefunds && availableRefunds.length > 0 ? 'flex-column' : ''">
              <v-img
                :src="rechargeIcon"
                width="30"
                height="30"
                contain
                class="mb-sm-0 mr-sm-2"
              />
              <span :class="allowRefunds && availableRefunds.length > 0 ? '' : 'ml-4'">{{ $t('main.recharge') }}</span>
            </div>
          </div>


          <div
            v-if="allowRefunds && availableRefunds.length > 0"
            :style="!isRefundAvailable || isRefundPending ? 'background: #00023033; cursor: pointer; border-radius: 1rem; height: 5.9rem; color: #fff;' : 'background: #000230; cursor: pointer; border-radius: 1rem; max-height: 95px; color: #fff;'"
            class="tooltip-refund ml-1 w-100 pa-5 d-flex flex-column flex-sm-row align-center justify-center text-center"
            @click="goToRefundProcess"
          >
            <div class="d-flex flex-column align-center justify-center">
              <div class="d-flex align-center justify-center" :class="availablePayment ? 'flex-column' : ''">
                <v-img
                  :src="refundIcon"
                  width="30"
                  height="30"
                  contain
                  class="mb-sm-0 mr-sm-2"
                />
                <span>{{ $t("balance_refund.title") }}</span>
              </div>
              <div v-if="!isRefundAvailable" class="d-flex align-center justify-center text-body-2">
                {{ refundAvailableDate }}
              </div>
            </div>
          </div>
        </div>
        <div v-if="hasDiscountCoupons" class="px-8">
          <div @click="$router.push({ name: routeNames.TOKENS, params: {selectedTab: 'benefits'} })" class="w-100 px-6 py-4 d-flex mt-3 justify-center clickable" style="border-radius: 20px; border: 2px solid var(--primary-color-blue);">
            <icon
              width="22"
              name="discount_coupon"
              color="#000230"
            ></icon>
            <span class="ml-2">
              {{ $t("main.check_your_benefits") }}
            </span>
          </div>
        </div>
      </v-main>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/views/layouts/MainLayout";
import { RequestService } from "../services/request.service";
import errorManager from "../services/error.manager";
import { mapState } from "vuex";
import { EventBus } from "../services/event-bus";
import { Message } from "../entities/app-entities/Message";
const requestService = new RequestService();

export default {
  props: ["auth", "routeNames"],
  data() {
    return {
      userData: null,
      refund: null,
      refundTooltip: false,
      availablePayment: true,
      rechargeIcon: require('@/assets/images/recharge_icon.png'),
      refundIcon: require('@/assets/images/refund_icon.png'),
      hasDiscountCoupons: false
    };
  },
  components: {
    Layout,
    BalanceData: require("@/components/BalanceData").default,
    BigButton: require("@/components/form-elements/BigButton").default,
  },
  computed: {
    ...mapState({
      refundAvailable: (state) =>
        state.customization.customization.economics.refund_available,
      customization: (state) => state.customization.customization,
      allowRefunds: (state) => { return (state.customization.customization.allow_refunds !== undefined) ? state.customization.customization.allow_refunds : true },
      availableRefunds: (state) => { return (state.customization.customization.available_refunds !== undefined) ? state.customization.customization.available_refunds : [] }
    }),
    refundAvailableDate() {
      const date = moment.parseZone(this.refundAvailable);
      return date.format("DD/MM/YYYY HH:mm");
    },
    isRefundPending() {
      return this.refund && this.refund.status === "PENDING" ? true : false;
    },
    isRefundAvailable() {
      return window.moment(this.refundAvailable).isBefore(new Date());
    },
    refundMessage() {
      return this.customization.economics.refund_unavailable_description.find(
        (objeto) => objeto.locale === this.$i18n.locale
      )
        ? this.customization.economics.refund_unavailable_description.find(
            (objeto) => objeto.locale === this.$i18n.locale
          ).content
        : this.customization.economics.refund_unavailable_description[0]
            .content;
    }
  },
  methods: {
    getUserData() {
      const context = this;
      requestService
        .getUserData(context)
        .then((userData) => {
          context.userData = userData;
        })
        .catch((error) => {
          errorManager.manageError(context, error);
        });

      requestService
        .getRefunds(context)
        .then(
          (refund) => (context.refund = refund != undefined ? refund : null)
        )
        .catch((error) => {
          if (error.status == 404) {
            context.refund = null;
          } else {
            errorManager.manageError(context, error);
          }
        });
    },
    goToRefundProcess() {

      if (this.isRefundPending) {
        this.sendMessage(this.$t('balance_refund.pending_refund'))
      }
      
      if (this.isRefundAvailable && !this.isRefundPending && this.userData.balance !== 0){
        if (this.availableRefunds.includes('FORM') && this.availableRefunds.includes('USER_WEBAPP')) {
          if (this.userData.balance === this.userData.refundableBalance){
            this.$router.push({ name: this.routeNames.BALANCE_REFUND })
          } else {
            this.goToRefundForm()
          }
        } else if (this.availableRefunds.includes('FORM')) {
          this.goToRefundForm()
        } else if (this.availableRefunds.includes('USER_WEBAPP')) {
          this.$router.push({ name: this.routeNames.BALANCE_REFUND })
        }
      }
      if (this.userData.balance === 0) {
        this.sendMessage(this.$t("error.user_not_balance"))
      }
    },
    goToRefundForm(){
      const tagOrUserId = this.userData.tag_id || this.userData.id
      if (window.location.href.includes('webapp-legacy-sandbox.go-fun.cloud')){
          window.open('https://d3df6co520lkqy.cloudfront.net/app/'+this.$route.params.instance+'?identifier='+tagOrUserId, '_blank'); //v1 sandbox
        } else if (window.location.href.includes('webapp-sandbox.go-fun.cloud')){
          window.open('https://d1a0oy26cjhfg8.cloudfront.net/app/'+this.$route.params.instance+'?identifier='+tagOrUserId, '_blank'); //v2 sandbox
        } else if (window.location.href.includes('ego.easygoband.com')){
          window.open('https://d37o4jix7u2tp7.cloudfront.net/app/'+this.$route.params.instance+'?identifier='+tagOrUserId, '_blank'); //v1 prod
        } else if (window.location.href.includes('webapp.go-fun.cloud')){
          window.open('https://d1ymjexbz9rp2q.cloudfront.net/app/'+this.$route.params.instance+'?identifier='+tagOrUserId, '_blank'); //v2 prod
        }else{
          window.open('https://d1a0oy26cjhfg8.cloudfront.net/app/'+this.$route.params.instance+'?identifier='+tagOrUserId, '_blank'); //v2 sandbox
        }
    },
    getEconomics() {
      const context = this;
      this.$store.dispatch("getEconomics", context).then((economics) => {
        context.availablePayment = economics.mit.enabled 
        || economics.paylands.enabled 
        || economics.mercadopago.enabled
        || economics.pvs.enabled
      });
    },
    sendMessage(value) {
      const message = new Message(value, 3000, "error");
      EventBus.$emit("showMessage", message);
    },
    getDiscountCoupons() {
      const context = this;
      requestService
        .getDiscountCoupons(context)
        .then((discountCoupons) => {
          context.hasDiscountCoupons = discountCoupons.length > 0 ? true : false 
        })
        .catch((error) => {
          errorManager.manageError(context, error);
        });
    }
  },
  created() {
    this.getEconomics();
    this.getUserData();
    this.getDiscountCoupons();
  },
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>
<style lang="css">
.sticky-balance {
  position: sticky;
  top: 6.8rem;
  z-index: 1;
}
.cursor-help {
  cursor: help;
}
.tooltip-refund {
  position: relative;
}
.icon-tooltip {
  position: absolute;
  top: 0px;
  right: -15px;
  background-color: aliceblue;
  border-radius: 25px;
}
@media (min-width: 470px) {
  .icon-tooltip {
    right: 0px;
  }
}
</style>
